@if (show) {
<h3 style="border:1px solid black;margin:25% 25%;padding:10px;text-align:center">
  @if (gettingScopes) {
  <p>PLEX Session Loading...</p>
  }
  @if (!gettingScopes) {
  <p>PLEX Session Failed to Load... Try the Refresh Button....</p>
  }
  <button type="button" kendoButton size="large" [svgIcon]="refreshIcon" [disabled]="gettingScopes" (click)="Refresh()">Refresh</button>
</h3>
}